/**
 * Sidebar/SetupMenu/SetupAccordion/index.tsx
 * desc: the Setup section while the sidebar is expanded — a toggle row and, when open, the grouped links inline
 * note: the open state is persisted
 */

import { ChevronDownIcon, ChevronUpIcon, ComponentsIcon } from '../../../Icon/typed';
import { classNames } from '../../../../utilities';
import { trackEvent } from '../../../../utilities/analytics';
import useSetupOpen from '../../hooks/useSetupOpen';
import SetupGroups from '../SetupGroups';
import type { SetupSectionProps } from '../types';

const SetupAccordion = ({ groups, isActive, label }: SetupSectionProps) => {
    //*************************************************
    //*****   Data   **********************************
    //*************************************************
    const { isOpen, toggle } = useSetupOpen();
    const Chevron = isOpen ? ChevronUpIcon : ChevronDownIcon;


    //*************************************************
    //*****   Public Functions   **********************
    //*************************************************
    const handleToggleClick = () => {
        trackEvent('Global: Sidebar - Setup Toggle (Click)');
        toggle();
    };


    //*************************************************
    //*****   Render   ********************************
    //*************************************************
    return (
        <div className="setup">
            <hr className="divider"/>

            <button
                type="button"
                className={ classNames('row', { selected: isActive }) }
                aria-controls={ isOpen ? 'sidebar-setup' : undefined }
                aria-expanded={ isOpen }
                onClick={ handleToggleClick }
            >
                <ComponentsIcon readOnly tooltip={ null }/>
                <span className="label">{ label }</span>
                <Chevron className="chevron" readOnly tooltip={ null }/>
            </button>

            { isOpen ?
                <div id="sidebar-setup" className="setup-body">
                    <SetupGroups groups={ groups }/>
                </div>
                :
                null
            }
        </div>
    );
};

export default SetupAccordion;
